import api from "@/services/api";

/**
 * @description Servicio para interactuar con el endpoint /pharmacies.
 * Gestiona el CRUD e importación masiva de farmacias.
 */
const pharmacyService = {};

const endpoint = "/pharmacies";

/**
 * @description Obtiene listado paginado de farmacias con filtros
 * @param {Object} params - Parámetros de búsqueda
 * @param {string} [params.searchInput] - Texto de búsqueda (nombre, CUIT)
 * @param {string} [params.status] - Filtrar por estado (active, inactive)
 * @param {number} [params.offset] - Offset para paginación
 * @param {number} [params.limit] - Límite de resultados
 * @returns {Promise<{docs: Array, total: number}>} Resultado paginado
 */
pharmacyService.query = function (params) {
  return api.get(endpoint, { params }).then((res) => res.data);
};

/**
 * @description Obtiene una farmacia por su ID
 * @param {string} id - ID de la farmacia
 * @returns {Promise<Object>} Datos de la farmacia
 */
pharmacyService.getById = function (id) {
  return api.get(`${endpoint}/${id}`).then((res) => res.data);
};

/**
 * @description Crea una nueva farmacia
 * @param {Object} data - Datos de la farmacia
 * @returns {Promise<Object>} Farmacia creada
 */
pharmacyService.create = function (data) {
  return api.post(endpoint, data).then((res) => res.data);
};

/**
 * @description Actualiza una farmacia existente
 * @param {string} id - ID de la farmacia
 * @param {Object} data - Campos a actualizar
 * @returns {Promise<Object>} Farmacia actualizada
 */
pharmacyService.update = function (id, data) {
  return api.put(`${endpoint}/${id}`, data).then((res) => res.data);
};

/**
 * @description Elimina una farmacia
 * @param {string} id - ID de la farmacia
 * @returns {Promise<void>}
 */
pharmacyService.remove = function (id) {
  return api.delete(`${endpoint}/${id}`);
};

/**
 * @description Importa farmacias desde archivo Excel/CSV
 * @param {File} file - Archivo a importar (.xlsx, .xls, .csv)
 * @returns {Promise<{imported: number, duplicates: number, total: number, errors: Array}>} Resultado
 */
pharmacyService.import = function (file) {
  const formData = new FormData();
  formData.append("file", file);
  return api
    .post(`${endpoint}/import`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => res.data);
};

export default pharmacyService;
